import { render, staticRenderFns } from "./TotalExpand.vue?vue&type=template&id=78c5a011&scoped=true&"
import script from "./TotalExpand.vue?vue&type=script&lang=js&"
export * from "./TotalExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5a011",
  null
  
)

export default component.exports